module.exports = __webpack_public_path__ + "assets/mstile-310x150.png";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/icons/mstile-310x150.png
// module id = 936
// module chunks = 17